import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

//Assets
import btnTop from "../../assets/images/ButtonTop.webp";
import LogoRadaria from "../../assets/images/logotipos/RADARIA-LOGOTIPO01.png";
import QR from "../../assets/images/QR.jpg";
import FaceboockIcon from "../../assets/icons/facebook-square.svg";
import InstagramIcon from "../../assets/icons/instagram.svg";
import IconWhatsapp from "../../assets/icons/icon _whatsapp.svg";
import IconAppStore from "../../assets/icons/app-store-ios-brands.png";
import IconPlayStore from "../../assets/icons/google-play-brands.png";
import IconEmail from "../../assets/icons/icon_email.png";
import DescriptionIcon from "@mui/icons-material/Description";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <footer className="">
      <article className="container-downloadApp bg-black pt-3 pb-3">
        <div className="d-flex flex-column align-items-center wrap-footer-qr justify-content-center gap-3">
          <img src={LogoRadaria} alt="logo de radaria" width={150} />
          <div
            style={{ width: "50%", position: "relative", borderRadius: "10px" }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "5px",
                backdropFilter: "blur(5px)",
                opacity: 1,
                zIndex: 999,
              }}
            />
            <img
              src={QR}
              alt="Qr"
              style={{ width: "100%", borderRadius: "10px" }}
            />
          </div>
          <div className="m-3 d-flex justify-content-center align-items-center">
            <Link
              className="m-1"
              to={"https://www.facebook.com/profile.php?id=61564072719509"}
              target="_blank"
            >
              <img src={FaceboockIcon} alt="" />
            </Link>
            <Link
              className="m-1"
              to={
                "https://www.instagram.com/radaria.mx?igsh=MTBncnQ3emhvazgxZA=="
              }
              target="_blank"
            >
              <img src={InstagramIcon} alt="Icono de instagram." />
            </Link>
          </div>
        </div>
        <div className="wrap-form-footer ">
          <p className="fs-4 text-center text-primary">
            Próximamente en tu tienda de apps favorita.
          </p>
          {/* <p className="text-info fs-4 text-center ">Descarga la APP</p> */}
          <p className="text-info fs-4 text-center ">¡Espérala!</p>
          <div className="d-flex gap-3">
            <img
              src={IconAppStore}
              alt="Icono de App Store"
              // width={40}
              height={39}
            />
            <img
              src={IconPlayStore}
              alt="Icono de Play Store"
              // width={40}
              height={39}
            />
          </div>
        </div>
      </article>
      <section className="wraper-info-footer">
        <div className="wraper-nav">
          <div className="subwraper-nav">
            <Link to={"/"}>INICIO</Link>
            <Link to="/about-us">¿QUIÉNES SOMOS?</Link>
            <Link to="/memberships">MEMBRESIAS</Link>
            <Link to="/auth">INICIAR SESIÓN</Link>
          </div>
          <div className="subwraper-nav">
            <Link to="/services">SERVICIOS</Link>
            <Link to="/community">COMUNIDAD</Link>
          </div>
        </div>
        <div className="wraper-contact mb-2">
          <Link
            className="m-1"
            to={
              "https://api.whatsapp.com/send?phone=525620033629&text=¡Hola! necesito información sobre mi plan de Radaria"
            }
          >
            <img src={IconWhatsapp} alt="" className="me-1" />
            +52 5620033629
          </Link>

          <Link className="m-1">
            <img src={IconEmail} alt="" className="me-1" />
            hola@radaria.mx
          </Link>
          <div className="mt-2 fw-bold">
            <DescriptionIcon className="text-primary" />
            <Link to="/privacy-policy">Política de privacidad</Link>
          </div>
        </div>
      </section>
      <div className="bg-primary d-flex wraper-license justify-content-around">
        <span className="text-dark m-2 ">
          &copy;2025 Radaria. Todos los derechos reservados.
        </span>
      </div>
      <button className="rounded-circle btn" onClick={scrollToTop}>
        <img src={btnTop} alt="Icon btn top" />
      </button>
    </footer>
  );
};

export default Footer;
